/**
 * History-mode routes. Only `/login` is public; every other route needs a truthy Vuex token.
 */
import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

const routes = [

  // PUBLIC ROUTES

  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/public/LoginView.vue'),
    meta: {
      public: true,
      title: 'Login',
    },
  },

  // PRIVATE ROUTES

  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/private/DashboardView.vue'),
    meta: {
      public: false,
      title: 'Dashboard',
    },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/private/SettingsView.vue'),
    meta: {
      public: false,
      title: 'Settings',
    },
  },
  {
    path: '/corporations',
    name: 'Corporations',
    component: () => import('@/views/private/CorporationsView.vue'),
    meta: {
      public: false,
      title: 'Corporations',
    },
  },
  {
    path: '/expense-accounts',
    name: 'Expense Accounts',
    component: () => import('@/views/private/ExpenseAccountsView.vue'),
    meta: {
      public: false,
      title: 'Expense Accounts',
    },
  },
  {
    path: '/expense-categories',
    name: 'Expense Categories',
    component: () => import('@/views/private/ExpenseCategoriesView.vue'),
    meta: {
      public: false,
      title: 'Expense Categories',
    },
  },
  {
    path: '/expense-tags',
    name: 'Expense Tags',
    component: () => import('@/views/private/ExpenseTagsView.vue'),
    meta: {
      public: false,
      title: 'Expense Tags',
    },
  },
  {
    path: '/expenses',
    name: 'Expenses',
    component: () => import('@/views/private/ExpensesView.vue'),
    meta: {
      public: false,
      title: 'Expenses',
    },
  },
  {
    path: '/asset-accounts',
    name: 'Asset Accounts',
    component: () => import('@/views/private/AssetAccountsView.vue'),
    meta: {
      public: false,
      title: 'Asset Accounts',
    },
  },
  {
    path: '/banks',
    name: 'Banks',
    component: () => import('@/views/private/BanksView.vue'),
    meta: {
      public: false,
      title: 'Banks',
    },
  },
  {
    path: '/investors',
    name: 'Investors',
    component: () => import('@/views/private/InvestorsView.vue'),
    meta: {
      public: false,
      title: 'Investors',
    },
  },
  {
    path: '/investments',
    name: 'Investments',
    component: () => import('@/views/private/InvestmentsView.vue'),
    meta: {
      public: false,
      title: 'Investments',
    },
  },
  {
    path: '/dividends',
    name: 'Dividends',
    component: () => import('@/views/private/DividendsView.vue'),
    meta: {
      public: false,
      title: 'Dividends',
    },
  },
  {
    path: '/customers',
    name: 'Customers',
    component: () => import('@/views/private/CustomersView.vue'),
    meta: {
      public: false,
      title: 'Customers',
    },
  },
  {
    path: '/accounts',
    name: 'Accounts',
    component: () => import('@/views/private/AccountsView.vue'),
    meta: {
      public: false,
      title: 'Accounts',
    },
  },
  {
    path: '/accounts/:accountId',
    name: 'Account',
    component: () => import('@/views/private/AccountView.vue'),
    meta: {
      public: false,
      title: 'Account',
    },
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    component: () => import('@/views/private/SubscriptionsView.vue'),
    meta: {
      public: false,
      title: 'Subscriptions',
    },
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: () => import('@/views/private/InvoicesView.vue'),
    meta: {
      public: false,
      title: 'Invoices',
    },
  },
  {
    path: '/transactions',
    name: 'Transactions',
    component: () => import('@/views/private/TransactionsView.vue'),
    meta: {
      public: false,
      title: 'Transactions',
    },
  },
  {
    path: '/documents',
    name: 'Documents',
    component: () => import('@/views/private/DocumentsView.vue'),
    meta: {
      public: false,
      title: 'Documents',
    },
  },
  {
    path: '/plans',
    name: 'Plans',
    component: () => import('@/views/private/PlansView.vue'),
    meta: {
      public: false,
      title: 'Plans',
    },
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/private/ProductsView.vue'),
    meta: {
      public: false,
      title: 'Products',
    },
  },
  {
    path: '/coupons',
    name: 'Coupons',
    component: () => import('@/views/private/CouponsView.vue'),
    meta: {
      public: false,
      title: 'Coupons',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    next();
  } else if (store.getters.authenticated) {
    next();
  } else {
    next('/login');
  }
});

router.afterEach((to) => {
  document.title = to.meta.title ? to.meta.title + ' | Webwalker Finance' : 'Webwalker Finance';
});

export default router;
